import { SET_WEBSHOP_TIPS_CONFIG, SET_WEBSHOP_TIPS_CONFIG_IS_LOADING } from '../../actionTypes/webshopTipsConfig'

const initialState = {
	config: null,
	tipsConfigIsLoading: false,
}

export function webshopTipsConfigReducer (state = initialState, action) {
	switch (action.type) {
		case SET_WEBSHOP_TIPS_CONFIG:
			return {
				...state,
				config: action.value,
			}
		case SET_WEBSHOP_TIPS_CONFIG_IS_LOADING:
			return {
				...state,
				tipsConfigIsLoading: action.value,
			}

		default:
			return state
	}
}
